import { render, staticRenderFns } from "./ChartConfigurationInput.vue?vue&type=template&id=2be89c6e&"
import script from "./ChartConfigurationInput.vue?vue&type=script&lang=ts&"
export * from "./ChartConfigurationInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports